// config.js
// Configuration settings for the application

export const BACKEND_CONFIG = {
    API_URL: "http://localhost:3000/api",
};

// Features configuration
export const FEATURES = {
    // Enable/disable Azure AI Vision integration (can be toggled in the UI)
    AZURE_VISION_ENABLED: true,
    // Use backend for processing (if false, will use client-side simulation)
    USE_BACKEND: true,
};

// Mock data configuration
export const MOCK_DATA = {
    // Whether to use mock data for demos and development
    // Set to false to use actual backend processing
    USE_MOCK_DATA: false,
};
